module.exports = __webpack_public_path__ + "img/2200.02ae4a0c.svg";